import Vue from 'vue'
import router from './router'
import store from './store'
import {sync} from 'vuex-router-sync'
import axios from 'axios'
import vueAxios from 'vue-axios'
import slick from 'vue-slick'
import gtag from 'vue-gtag'

import header from './components/header.vue'
import footer from './components/footer.vue'
import index from './views/index.vue'
import top from './components/top.vue'
import works from './components/works.vue'
import products from './components/products.vue'
import detail from './components/detail.vue'
import news from './components/news.vue'
import article from './components/article.vue'
import lp from './components/lp.vue'
import search from './components/searchBox.vue'


const URL = process.env.VUE_APP_CLIENTAPI+'/UFWE'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$uri = URL
// Vue.prototype.$slick = slick
Vue.use(vueAxios,axios,slick)

Vue.use(gtag, {
  config:{ id:'G-S69VXZJE85' },
  params: {
    send_page_view: false
  },
},router)

Vue.use(gtag, {
  config:{ id:'UA-196118927-1' },
  params:{
    send_page_view: false
  },
},router)


sync(store,router)


new Vue({
  header,
  router,
  store,
  render: h => h(header)
}).$mount('#header')

new Vue({
  footer,
  router,
  store,
  render: h => h(footer)
}).$mount('#footer')

new Vue({
  router,
  store,
  top,
  products,
  works,
  detail,
  news,
  article,
  lp,
  search,
  render: h =>h(index)
}).$mount("#index")